export default "__VITE_ASSET__ta8iqspw__"